import { Download, fileNameWithTime } from "../../../helpers/download";
import { NotifyHelper } from "../../../helpers/toast";
import { eReportActionsObj } from "../../action-types/report/IReportActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const reportActions = {
  ...generateActions(eReportActionsObj, "REPORT"),
  ...generateActionForKey(
    eReportActionsObj,
    "REPORT",
    "EXPORT_EXCEL_BAO_CAO_SUCCESS",
    (data: any) => {
      Download.Excel(data, `${fileNameWithTime("Báo cáo theo kỳ")}.xlsx`);
      NotifyHelper.Success("Thành công!");
    }
  ),
  ...generateActionForKey(
    eReportActionsObj,
    "REPORT",
    "EXPORT_EXCEL_BAO_CAO_ERRR",
    (m: any) => {
      NotifyHelper.Error(m);
    }
  ),
};
